// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__kVInL","addWidgetButton":"Header_addWidgetButton__6etbB","dashboardTabs":"Header_dashboardTabs__3Trxt","active":"Header_active__aYJDo"};